import { useMemo } from "react";

import {
	getCancellationInfo,
	getCancellationNotice,
	LocalCancellationFields,
	StripeSubscriptionCancellationFields,
} from "./cancellation.utils";

/**
 * The pending-cancellation notice for the billing overview, or `null` when there is nothing to say.
 *
 * Both sources are consulted on purpose: the Stripe object is richer (it distinguishes a trial,
 * discount and billing-cycle ending) but reaches the browser through a per-process cache on the
 * API, so it can still describe a subscription as active moments after it was cancelled. The
 * local row is written by our own cancel path and is correct in every container (PREC-3922).
 */
export const useCancellationNotice = (
	stripeSubscription: StripeSubscriptionCancellationFields | null | undefined,
	local: LocalCancellationFields | null | undefined
) => {
	const info = useMemo(
		() => getCancellationInfo(stripeSubscription, local),
		[stripeSubscription, local]
	);

	return useMemo(() => (info ? getCancellationNotice(info) : null), [info]);
};
